import React, { useEffect, useState } from "react";
import { useAppSelector } from "../../../infra/hooks";

function DTOUpdateDEpPrPic() {
  const selector = useAppSelector((state) => state.profilePicSlice.profilePic);

  useEffect(() => {
    console.log("upatedeee--");
    // setProfilePic(selector);
  }, [selector]);

  return <></>;
}
export default DTOUpdateDEpPrPic;
